import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  MessageSquare, 
  Users, 
  Zap, 
  Magnet 
} from 'lucide-react';

const mobileNavItems = [
  { id: 'dashboard', label: 'Home', icon: LayoutDashboard, path: '/' },
  { id: 'inbox', label: 'Inbox', icon: MessageSquare, path: '/inbox' },
  { id: 'leads', label: 'Leads', icon: Users, path: '/leads' },
  { id: 'automations', label: 'Auto', icon: Zap, path: '/automations' },
  { id: 'capture', label: 'Tools', icon: Magnet, path: '/capture' },
];

const MobileNav = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-notion-border flex items-center justify-around h-[60px] z-50 shadow-nav pb-1">
      {mobileNavItems.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.id}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center w-full h-full gap-1 transition-colors ${
                isActive ? 'text-stone-800' : 'text-notion-text-light hover:text-stone-600'
              }`
            }
          >
            <div className="relative">
              <Icon className="w-5 h-5" />
              {item.badge && (
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-status-hot-bg text-status-hot-text border border-white rounded-full text-[8px] flex items-center justify-center font-bold">
                  {item.badge}
                </span>
              )}
            </div>
            <span className="text-[10px] font-medium">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default MobileNav;
